import { j as e } from "../../jsx-runtime-Wav_3Wde.js";
import { useState as k, useEffect as u } from "react";
import { styled as p, useTheme as j, css as B } from "styled-components";
import a from "../../Button/Button.mjs";
import { Flex as s } from "../../Flexbox/Flexbox.mjs";
import { Modal as P, ModalContent as w, ModalInnerWrapper as I } from "../../Modal/Modal.mjs";
import { a as A } from "../../brands-CoixlYYY.js";
import { generateId as O } from "../../common/utils/index.mjs";
import { useBrand as _ } from "../../providers/BrandProvider/brandProvider.mjs";
import E from "../../typography/Heading/Heading.mjs";
import R from "../../typography/Link/Link.mjs";
import T from "../../typography/Paragraph/Paragraph.mjs";
import { COOKIE_MANAGEMENT_EVENT_ACTION as n } from "../cookieManagementTypes.mjs";
import v from "../hooks/useCookieBanner.mjs";
import y from "../utils/expireInvalidCookies.mjs";
import "styled-system";
import "../../RadioGroup/Radio.mjs";
import "../../RadioGroup/RadioGroup.mjs";
import "../../typography/Text/Text.mjs";
import "../CookieBanner/HideOnError.mjs";
import F from "./FullPagecookieBannerPolicyLinks.mjs";
import M from "./FullPageCookieBannerModal.mjs";
import N from "./FullPageHideOnError.mjs";
const W = ({ id: r = O(), allowList: c = A, policyLinks: d = F, onCookieManagementEvent: o, isOpen: f }) => {
  const x = _(c), t = /* @__PURE__ */ j(), [C, m] = k(!1), i = (h) => {
    g({
      ...h,
      onCookieManagementEvent: o
    });
  };
  u(() => {
    y();
  }, []);
  const { shouldDisplayCookieBanner: l, updatePreferences: g } = v({
    onCookieManagementEvent: o
  });
  return u(() => {
    l && o(n.BANNER_FIRST_RENDER);
  }, [
    l,
    o
  ]), l ? /* @__PURE__ */ e.jsxs(e.Fragment, {
    children: [
      /* @__PURE__ */ e.jsx(P, {
        id: "full-page-cookie-banner",
        "data-qa-id": r,
        heading: "Your cookie preferences",
        showHeading: !1,
        allowDismiss: !1,
        isOpen: f,
        rootId: "root",
        ModalWrapper: S,
        ModalContentWrapper: b,
        children: /* @__PURE__ */ e.jsxs(s, {
          flexDirection: "column",
          justifyContent: "center",
          padding: [
            "xs",
            null,
            null
          ],
          children: [
            /* @__PURE__ */ e.jsx(E, {
              size: "small",
              level: "3",
              textAlign: "center",
              pb: [
                "xs",
                null,
                "sm"
              ],
              children: "Your cookie preferences"
            }),
            /* @__PURE__ */ e.jsxs(T, {
              variant: t.components.fullPageCookieBanner.textVariant,
              textAlign: "center",
              children: [
                "We use cookies to improve your experience on our website and to keep everything working properly. To find out more,",
                " ",
                /* @__PURE__ */ e.jsx(L, {
                  external: !0,
                  href: d[x],
                  variant: t.components.fullPageCookieBanner.textVariant,
                  children: "read our Cookie Policy."
                })
              ]
            }),
            /* @__PURE__ */ e.jsxs(s, {
              flexDirection: [
                "column",
                null,
                "row"
              ],
              width: [
                "100%",
                "auto"
              ],
              marginTop: "lg",
              gap: [
                "xs",
                null,
                "sm"
              ],
              mx: "auto",
              my: "sm",
              children: [
                /* @__PURE__ */ e.jsx(a, {
                  "data-qa-id": "accept-all-button",
                  onClick: () => {
                    i({
                      allowSiteImprovementCookies: !0,
                      allowAdvertisingCookies: !0
                    }), o(n.ACCEPT_ALL_COOKIES);
                  },
                  children: "Accept all"
                }),
                /* @__PURE__ */ e.jsx(a, {
                  "data-qa-id": "reject-all-button",
                  variant: t.components.fullPageCookieBanner.rejectButtonVariant,
                  onClick: () => {
                    i({
                      allowSiteImprovementCookies: !1,
                      allowAdvertisingCookies: !1
                    }), o(n.REJECT_ALL_COOKIES);
                  },
                  children: "Reject all"
                })
              ]
            }),
            /* @__PURE__ */ e.jsx(s, {
              mx: "auto",
              children: /* @__PURE__ */ e.jsx(a, {
                "data-qa-id": "full-page-manage-cookies-button",
                variant: t.components.fullPageCookieBanner.manageButtonVariant,
                onClick: () => {
                  m(!0), o == null || o(n.OPEN_COOKIE_MODAL);
                },
                children: "Manage cookies"
              })
            })
          ]
        })
      }),
      /* @__PURE__ */ e.jsx(M, {
        isOpen: C,
        allowList: c,
        policyLinks: d,
        onClose: () => {
          m(!1);
        },
        setCookieLevel: i
      })
    ]
  }) : null;
}, b = /* @__PURE__ */ p(w).withConfig({
  componentId: "sc-81f03531-0"
})([
  "",
  ""
], ({ theme: r }) => r.components.fullPageCookieBanner.roundedModalContentWrapper), L = /* @__PURE__ */ p(R).withConfig({
  componentId: "sc-81f03531-1"
})([
  "",
  ""
], () => /* @__PURE__ */ B([
  "white-space:nowrap;"
])), S = /* @__PURE__ */ p(I).withConfig({
  componentId: "sc-81f03531-2"
})([
  "",
  ""
], ({ theme: r }) => r.components.fullPageCookieBanner.FullPageModalWrapper), pe = (r) => /* @__PURE__ */ e.jsx(N, {
  onCookieManagementEvent: r.onCookieManagementEvent,
  children: /* @__PURE__ */ e.jsx(W, {
    ...r
  })
});
export {
  W as FullPageCookieBannerRaw,
  pe as default
};
